import React, { useState } from "react";
import Table from "../../../core/common/dataTable/index";

const Cheques = () => {
  const [chequesData, setchequesData] = useState<ChequesData[]>([])


  type ChequesData = {
    full_name: string;
    key: number;
    EmpId: string;
    Name: string;
    Status: string;
    id: any;
  };

  const columns = [
    {
      title: "Sr No",
      dataIndex: "EmpId",
      render: (text: string) => (
        <span>{text}</span>
      ),
      sorter: (a: ChequesData, b: ChequesData) =>
        a.EmpId.localeCompare(b.EmpId),
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: any, record: ChequesData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record.Name}
            </p>
          </div>
        </div>
      ),
      sorter: (a: ChequesData, b: ChequesData) =>
        a.Name.localeCompare(b.Name),
    },

    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string) => (
        <span
          className={`badge ${text === "Active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text}
        </span>
      ),
      sorter: (a: ChequesData, b: ChequesData) =>
        a.Status.localeCompare(b.Status),
    },
  ];
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="card">
          <div className="card-body p-0">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              Cheques Data
            </div>
            <div>
              <Table
                dataSource={chequesData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cheques;
